(function ($) {
   // Initialize slick slider only if there are slides to show
   var $slider = $('.header-image-section-slider');
   var slideCount = $slider.children().length;
   
   if (slideCount > 0) {
      $slider.slick({ 
         infinite: true,
         fade: true,
         arrows: false,
         dots: true,
         dotsClass: "custom-hero-dots slick-dots ",
         autoplay: true,
         autoplaySpeed: 3000,
      });
   }
})(jQuery);